module.exports = __webpack_public_path__ + "static/media/SOLUS_LR_MARKER_202.5deg.e1895246.png";